export default [
  {
    path: "/",
    name: "root",
    redirect: "/landing",
  },
  {
    path: "/landing",
    name: "landing",
    component: () => import("@/views/landing/index.vue"),
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/abnormal/404.vue"),
    meta: { title: "404 Not Found" },
  },
];
